import React from 'react';
import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useAuth } from '../../contexts/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { currentUser, userData, loading } = useAuth();

  // Check if authentication should be bypassed for development
  const skipAuth = process.env.REACT_APP_SKIP_AUTH === 'true';

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-100">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900 mx-auto"></div>
          <p className="mt-2 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (!currentUser && !skipAuth) {
    return <Navigate to="/login" />;
  }

  // Check if Google user needs to complete profile (skip if auth is bypassed)
  if (!skipAuth && currentUser) {
    const isGoogleUser = currentUser.providerData?.some(
      (provider) => provider.providerId === 'google.com'
    );
    const attorneyRoles = [
      'Defense Attorney (Private Practice)',
      'Public Defender',
      'Prosecutor'
    ];
    const hasProfileData = !!(
      userData?.role &&
      (attorneyRoles.includes(userData.role) || userData.organization)
    );

    if (isGoogleUser && !hasProfileData) {
      return <Navigate to="/complete-profile" />;
    }
  }

  return children;
};

ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired
};

export default ProtectedRoute;
